import "./style.css";

function Input({ className = "", ...rest }) {
  return <input className={`form-control ${className}`} {...rest} />;
}
export default Input;
